import * as React from 'react'

import { IAppContextProps, withAppContext } from "../../context/AppContext"
import * as Model from '../../models'
import OrderForm from './FormGeneric'

interface IProps extends IAppContextProps {
  batchid: string
  formTitle: string
}

const FormCreate: React.SFC<IProps> = (props) => {
  const state = props.appcontext.getOrderState()
  const action = props.appcontext.getOrderAction()

  const handleCreate = (order: Model.Form.IOrder) => {
    action.createRequest(order)
  }

  const handleCancel = () => {
    action.closeCreateForm()
  }

  return (
    <OrderForm isOpen={state.createStatus.isFormOpen} formTitle={props.formTitle} isCreate={true} order={state.createStatus.data} batchid={props.batchid} onCreate={handleCreate} onCancel={handleCancel} errorMessage={state.createStatus.errorMessage} isLoading={state.createStatus.isSubmitting} />
  )
}

export default withAppContext(FormCreate)